export default "__VITE_ASSET__CMpBYAS0__"